import { render, staticRenderFns } from "./FileViewModal.vue?vue&type=template&id=32fc5c4e"
import script from "./FileViewModal.vue?vue&type=script&lang=js"
export * from "./FileViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports